export var SourceProject;
(function (SourceProject) {
    SourceProject["WebSdk"] = "websdk";
    SourceProject["Onboardings"] = "onboardings";
})(SourceProject || (SourceProject = {}));
